import clsx from 'clsx'
import { getCaseStatusIndicatorStatuses, kCaseStatusIndicatorDots } from '@/citator/components/case-status-indicators'

export type CaseStatusIndicatorsProps = {
  /* Statuses of every case in the list; duplicates and non-warning statuses are ignored */
  caseStatuses: ReadonlyArray<string | null | undefined>
  className?: string
}

/**
 * Overlapping dots flagging which warning statuses appear in a list of cases. Visual only:
 * pair it with `getCaseStatusIndicatorsLabel` in the parent's accessible name.
 */
export function CaseStatusIndicators({ caseStatuses, className }: CaseStatusIndicatorsProps) {
  const statuses = getCaseStatusIndicatorStatuses(caseStatuses)
  if (statuses.length === 0) return null

  return (
    <span className={clsx('flex items-center', className)} aria-hidden="true">
      {statuses.map((status) => (
        <span
          key={status}
          data-testid={`case-status-indicator-${status}`}
          className={clsx('size-3 -mr-1 last:mr-0 rounded-full border-[0.5px] border-brand-neutral-50', kCaseStatusIndicatorDots[status].colorClass)}
        />
      ))}
    </span>
  )
}
